"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.granularityIntlCodes = void 0;
exports.granularityIntlCodes = {
    "GDC.time.minute": "minute",
    "GDC.time.hour": "hour",
    "GDC.time.date": "day",
    "GDC.time.week_us": "week",
    "GDC.time.month": "month",
    "GDC.time.quarter": "quarter",
    "GDC.time.year": "year",
};
//# sourceMappingURL=i18n.js.map